import React, { useState } from "react";
import PropTypes from "prop-types";
import EyeOpen from "~/images/show_pass.svg?react";
import EyeClosed from "~/images/hide_pass.svg?react";

import Info from "~/images/info_icon.svg?react";
import Info2 from "~/images/info.svg?react";

import { Popover, PopoverContent, PopoverTrigger } from "./popover";

const InputField = ({
  id,
  label,
  model,
  placeholder = null,
  onChange,
  name,
  labelStyle = "block font-normal text-white text-left",
  inputStyle = "w-full p-4 outline-none text-left leading-tight rounded-2xl bg-white",
  type = "text",
  haveInfo = false,
  infoMsg = "",
  hasError = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);

  const isPassword = type === "password";
  const inputType = isPassword && showPassword ? "text" : type;

  const SelectedInfoIcon = isPassword ? Info2 : Info;

  return (
    <div
      className={`flex flex-col gap-1  
      p-1 sm:p-2 px-3 sm:px-2 
      text-13px sm:text-base`}
    >
      {/* Label + Info */}
      <div className="flex items-center gap-2">
        <label
          className={labelStyle}
          htmlFor={id}
        >
          {label}
        </label>

        {haveInfo && (
          <Popover
            open={open}
            onOpenChange={setOpen}
          >
            <PopoverTrigger asChild>
              <button
                type="button"
                onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)}
                className="text-gray-500 hover:text-btn-tertiary cursor-pointer pb-1 ml-2"
              >
                <SelectedInfoIcon
                  className={`w-auto fill-current text-white ${!isPassword ? "h-6" : ""}`}
                />
              </button>
            </PopoverTrigger>

            <PopoverContent
              side="top"
              align="center"
              className="p-2 text-sm lg:max-w-lg max-w-sm "
            >
              {infoMsg}
            </PopoverContent>
          </Popover>
        )}
      </div>

      <div
        className={`${inputStyle} relative w-full flex border-2 ${
          hasError ? "border-[#CF4711]" : "border-transparent"
        }`}
      >
        <input
          className={`pr-10 bg-transparent outline-none w-full`}
          id={id}
          type={inputType}
          name={name}
          value={model || ""}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="right-3 cursor-pointer"
          >
            {showPassword ? (
              <EyeClosed className="w-auto h-full" />
            ) : (
              <EyeOpen
                className="w-auto h-full p-0.5
              "
              />
            )}
          </button>
        )}
      </div>
    </div>
  );
};

InputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  model: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  labelStyle: PropTypes.string,
  inputStyle: PropTypes.string,
  type: PropTypes.string,
  haveInfo: PropTypes.bool,
  infoMsg: PropTypes.string,
};

export default InputField;
